<template>
  <div>
    <div class="row order-no-area mt-3">
      <div class="col">
        <div class="order-no"><trans-text i18nKey="ui['9'][1]" /></div>
      </div>
    </div>
    <div class="form-wrap">
      <div class="form-list py-1">
        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][2]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.family_name}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][3]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.given_name}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" >
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][4]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.address_1}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][5]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.address_2}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][6]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.city}}</p>
          </div>
          <div class="col-12 form-hr">
          <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][7]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.prefecture}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][8]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.zip_code}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][9]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.country_name}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>


        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][10]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.phone_nunber}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][11]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{storeInput.email}}</p>
          </div>
        </div>

        <div name="childInfo" v-for="childInfoInput of storeChildInfoInput">
          <div class="px-2 content-header" style="">{{childInfoInput.event_name}}</div>
          <!-- 入力項目-->
          <div class="form-group row">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][12]"/></label>
            <div class="col-7">
              <p class="form-control-static">{{childInfoInput.family_name}}</p>
            </div>
            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][13]"/></label>
            <div class="col-7">
              <p class="form-control-static">{{childInfoInput.given_name}}</p>
            </div>
            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][14]"/></label>
            <div class="col-7">
              <p class="form-control-static">{{childInfoInput.school_name}}</p>
            </div>
            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][15]"/></label>
            <div class="col-7">
              <p class="form-control-static">{{childInfoInput.group_name}}</p>
            </div>
            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui['9'][16]"/></label>
            <div class="col-7">
              <p class="form-control-static">{{familyRelationKeyById[childInfoInput.family_relation_id] && familyRelationKeyById[childInfoInput.family_relation_id].name}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- フォーム送信UI -->
      <div class="row text-center" >
        <div class="offset-1 col-10 col-sm-10 col-md-10">
          <div class="my-4">
            <!--<button type="button" class="btn w-100 btn-lg btn-default" ><trans-text i18nKey="ui[8][23]" :adjustLangFontSizes="{}"/></button>-->


            <router-link tag="button"class="btn w-100 btn-lg btn-default" :to="{ name: 'mypage::event::order_form', params: {} }" >
              <trans-text i18nKey="ui['9'][17]"/>
            </router-link>

          </div>
        </div>
      </div>

        <div class="form-list py-1">
          <!-- 入力項目-->
          <div class="form-group row">
            <div class="col-12">
              <p class="form-control-static px-2"><trans-text i18nKey="ui['9'][18]"/></p>
            </div>
            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row" >

            <div class="col-12">
              <div class="px-2 text-center">
                <label class="custom-control custom-checkbox" >
                  <input type="checkbox" class="custom-control-input" v-model="input.isOnlyThisTime">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description"><trans-text i18nKey="ui['9'][19]"/></span>
                </label>
              </div>
            </div>
          </div>

      </div>

    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    props:["storeData"],
    components: {
    },
    data () {
      return {
        familyRelations:{},
        input: {
          isOnlyThisTime:false,
          family_name: "",
          given_name: "",
          address_1:"",
          address_2:"",
          city:"",
          prefecture:"",
          zip_code:"",
          phone_nunber:"",
          country_name:"",
          email: "",
          password: "",
          confirm_password: "",
        }
      }
    },
    validations: {
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        email: {
          required,
          email,
        },
        password: {
          required,
          alphaNum,
          minLength: minLength(8),
        },
        confirm_password: {
          required,
          sameAsPassword: sameAs('password'),
        },
      },
    },
    watch:{
        "input.isOnlyThisTime"(){
            this.$emit("changeIsOnlyThisTime",this.input.isOnlyThisTime)
        }
    },
    mounted(){
      Promise.all([
        app.make("axios").get(`v1/util/family-relation `,{}),
      ]).then( ([familyRelation]) => {
        this.familyRelations = familyRelation.data.data.family_relations
      })
    },
    computed:{
      familyRelationKeyById(){
        return app.make("_").keyBy(this.familyRelations,(item)=>{
            return item.id
        })
      },
      storeInput(){
          return this.storeData.input || {}
      },
      storeChildInfoInput(){
        return this.storeData.child_info_input || {}
      }
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .size-info{
    padding:.5rem 1rem;
    border:1px solid #7bb600;
    font-size: .7rem;
    .size-label{
      color:#7bb600;

    }
  }
  .order-no {
    background-color: #82ba1d;
    color: #fff;
    font-size: 0.9rem;
    font-weight: bold;
    padding: .1rem .5rem;
  }
  .child-select-area{

    .child-select-item{
      .btn-child{
        background-color: #fff;
        padding-left: 2rem;
        position: relative;
        white-space:normal !important;
        word-wrap:break-word;
        &:before{
          font-family: FontAwesome;
          content: '\f007';
          font-size:1.2rem;
          color: #82ba1d;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(0);
          left: 5%;
        }
        &:hover{
          background-color: #72b400;
          color: #fff;
          &:before{
            color: #fff;
          }
        }

      }

    }
  }

  .price-area {
    background-color: #fff;
    border:1px solid #7bb600;
    padding:.5rem 1rem;

  }
  .price-info-wrap{
    border:1px solid #ec4200;
    background-color: #fff;
    position: relative;
    .price-info {
      .price-label {
        padding: 1px 4px 0 4px;
        color: #ec4200;
      }
      .price-value {
        font-size: 1.2rem;
        padding: 0 4px;
      }
    }
  }

  .content-header{
    background-color: #82ba1d;
    color:#fff;
  }

</style>



// WEBPACK FOOTER //
// PageForm.vue?8500921c